/**
 * Collection toolbar filter by product tag.
 * Multiple tabs can be active (OR): product shows if it matches any selected tag.
 * Blank filter_tag ("All") in the selection matches every product for the toolbar slice.
 * When a filter sidebar exists, this script only toggles UI; sidebar script applies visibility.
 *
 * Debug logging is commented out in this file; search for "FILTER DEBUG" to restore.
 */
(function () {
  const CONTAINER_SELECTOR = '[data-collection-toolbar-filters]';
  const BUTTON_SELECTOR = '[data-filter-tag]';
  const SIDEBAR_SELECTOR = '[data-collection-filter-sidebar]';
  /** Sidebar markup always exists on collection grid; only treat as "combo" when real filter inputs are present (sidebar script loaded). */
  const SIDEBAR_HAS_FILTERS_SELECTOR =
    '[data-collection-filter-sidebar] [data-filter-sidebar-tag]';
  const COMBINED_FILTER_EVENT = 'bioligent:collection-toolbar-filter';
  const GRID_SELECTOR = '#main-collection-product-grid';
  const PRODUCT_SELECTOR = '.product-item';
  const HIDDEN_CLASS = 'collection-toolbar-filter-hidden';
  const NO_RESULTS_SELECTOR = '[data-collection-no-results]';

  /* FILTER DEBUG — uncomment the helper + logFilters body below and remove the no-op logFilters.
  function filtersDebugEnabled() {
    try {
      if (typeof window === "undefined") return true;
      if (window.BIOLIGENT_DEBUG_COLLECTION_FILTERS === false) return false;
      if (/(?:^|[?&])debug_filters=0(?:&|$)/.test(String(window.location.search || "")))
        return false;
      return true;
    } catch (e) {
      return true;
    }
  }

  function logFilters(message, data) {
    if (!filtersDebugEnabled()) return;
    if (data !== undefined) {
      console.log("[Bioligent filters]", message, data);
    } else {
      console.log("[Bioligent filters]", message);
    }
  }
  */

  function logFilters() {
    /* no-op while FILTER DEBUG block above is disabled */
  }

  function normalizeTag(tag) {
    if (!tag || typeof tag !== 'string') return '';
    return tag.trim().toLowerCase().replace(/\s+/g, '-');
  }

  function getProductTags(productEl) {
    const raw = productEl.getAttribute('data-product-tags');
    if (!raw) return [];
    return raw.split(',').map(function (t) {
      return normalizeTag(t);
    });
  }

  function getActiveToolbarTags(container) {
    var tags = [];
    container.querySelectorAll('.collection-toolbar__nav-link--active').forEach(function (b) {
      tags.push(normalizeTag(b.getAttribute('data-filter-tag') || ''));
    });
    return tags;
  }

  function productMatchesToolbarTags(productTags, toolbarTags) {
    if (!toolbarTags.length) return true;
    for (var i = 0; i < toolbarTags.length; i++) {
      if (toolbarTags[i] === '') return true;
      if (productTags.indexOf(toolbarTags[i]) !== -1) return true;
    }
    return false;
  }

  function updateNoResultsMessage(productItems) {
    var noResults = document.querySelector(NO_RESULTS_SELECTOR);
    if (!noResults) return;
    var visibleCount = 0;
    productItems.forEach(function (item) {
      if (!item.classList.contains(HIDDEN_CLASS)) visibleCount++;
    });
    noResults.style.display = visibleCount === 0 ? '' : 'none';
  }

  /**
   * ?filter=tag or ?filter=tag1,tag2 — same normalization as collection-filter-sidebar.js
   */
  function getFilterTagsFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search || '');
      var raw = params.get('filter') || params.get('tags');
      if (!raw || typeof raw !== 'string') return [];
      return raw.split(',').map(function (s) {
        return normalizeTag(s);
      }).filter(function (t) {
        return t.length > 0;
      });
    } catch (e) {
      return [];
    }
  }

  function activateToolbarButtonsForTags(container, tags) {
    if (!tags.length) return;
    container.querySelectorAll(BUTTON_SELECTOR).forEach(function (btn) {
      var tag = normalizeTag(btn.getAttribute('data-filter-tag') || '');
      if (tag && tags.indexOf(tag) !== -1) {
        btn.classList.add('collection-toolbar__nav-link--active');
        btn.setAttribute('aria-pressed', 'true');
      }
    });
  }

  function applyInitialFiltersFromUrlToolbarOnly(container, productItems) {
    var tags = getFilterTagsFromUrl();
    if (!tags.length) return;
    activateToolbarButtonsForTags(container, tags);
    applyToolbarFilter(container, productItems);
  }

  function applyToolbarFilter(container, productItems) {
    var toolbarTags = getActiveToolbarTags(container);
    productItems.forEach(function (item) {
      var tags = getProductTags(item);
      var show = productMatchesToolbarTags(tags, toolbarTags);
      item.classList.toggle(HIDDEN_CLASS, !show);
      item.setAttribute('aria-hidden', show ? 'false' : 'true');
    });
    updateNoResultsMessage(productItems);
  }

  function init() {
    var container = document.querySelector(CONTAINER_SELECTOR);
    var grid = document.querySelector(GRID_SELECTOR);
    if (!container || !grid) return;

    var buttons = container.querySelectorAll(BUTTON_SELECTOR);
    var productItems = grid.querySelectorAll(PRODUCT_SELECTOR);
    if (!buttons.length) return;

    var useCombinedFiltering = !!document.querySelector(SIDEBAR_HAS_FILTERS_SELECTOR);

    buttons.forEach(function (btn) {
      btn.addEventListener(
        'click',
        function () {
          var nextActive = !btn.classList.contains('collection-toolbar__nav-link--active');
          btn.classList.toggle('collection-toolbar__nav-link--active', nextActive);
          btn.setAttribute('aria-pressed', nextActive ? 'true' : 'false');
          logFilters("toolbar tab click", {
            label: btn.getAttribute("data-filter-label"),
            dataFilterTag: btn.getAttribute("data-filter-tag"),
            nextActive: nextActive,
            useCombinedFiltering: useCombinedFiltering,
            willDispatch: useCombinedFiltering,
          });
          if (useCombinedFiltering) {
            document.dispatchEvent(new CustomEvent(COMBINED_FILTER_EVENT));
          } else {
            applyToolbarFilter(container, productItems);
          }
        },
        true,
      );
    });

    logFilters("collection-toolbar-filter.js ready", {
      useCombinedFiltering: useCombinedFiltering,
    });

    /* Sidebar + toolbar: URL init is handled by collection-filter-sidebar.js */
    if (!useCombinedFiltering) {
      if (productItems.length) {
        applyInitialFiltersFromUrlToolbarOnly(container, productItems);
      } else {
        var urlTags = getFilterTagsFromUrl();
        if (urlTags.length) {
          activateToolbarButtonsForTags(container, urlTags);
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
